import { useLang } from '@/hooks/useLang';

const BASE = 'https://www.yamamoto-ss.co.jp/sp_recycle';

export function ConceptSection() {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-[#0a0a0a]">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[520px]">
        {/* Image side */}
        <div className="relative overflow-hidden min-h-[320px] lg:min-h-0">
          <img
            src={`${BASE}/_resources/img_top/learnmore_concept.jpg`}
            alt="Our Philosophy"
            className="absolute inset-0 w-full h-full object-cover object-top"
            style={{ filter: 'brightness(0.6) saturate(0.7)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0a0a0a]"></div>
          {/* Floating number */}
          <div className="absolute bottom-8 left-8 text-white/10 text-[120px] font-black leading-none select-none">01</div>
        </div>

        {/* Content side */}
        <div className="flex flex-col justify-center px-12 py-16 lg:py-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#c0392b]"></div>
            <span className="text-[#c0392b] text-xs font-bold uppercase tracking-[0.2em]">
              {t('Philosophy', '開発への思い')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-6">
            {t(
              <>Manufacturing<br />for a <span className="text-[#c0392b]">better</span> world.</>,
              <>モノづくりで<br /><span className="text-[#c0392b]">業界</span>に良い変化を</>
            )}
          </h2>
          <p className="text-white/50 text-sm leading-loose mb-8">
            {t(
              'Through manufacturing, we want to bring positive change to the recycling industry. This is the shared belief behind every piece of equipment we build — from the smallest component to the largest system.',
              'モノづくりを通して、業界に良い変化を起こしたい。私たちのつくる環境機器全てに共通する思いです。'
            )}
          </p>
          <a
            href={`${BASE}/concept/`}
            className="group inline-flex items-center gap-3 text-white text-sm font-bold border border-white/20 px-6 py-3 hover:border-[#c0392b] hover:text-[#c0392b] transition-all duration-300 cursor-pointer whitespace-nowrap w-fit"
          >
            {t('Read Our Philosophy', '開発への思いを読む')}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-[#0a0a0a]">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[520px]">
        {/* Content side */}
        <div className="flex flex-col justify-center px-12 py-16 lg:py-20 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#c0392b]"></div>
            <span className="text-[#c0392b] text-xs font-bold uppercase tracking-[0.2em]">
              {t('About Us', '私たちについて')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-6">
            {t(
              <>100+ years of<br /><span className="text-[#c0392b]">precision</span> engineering.</>,
              <>100年以上の<br /><span className="text-[#c0392b]">精密</span>機械製造</>
            )}
          </h2>
          <p className="text-white/50 text-sm leading-loose mb-8">
            {t(
              'Founded in 1918, Yamamoto is a century-old Japanese machinery manufacturer. We partner with recyclers and waste processors across North America to build a brighter future for the industry.',
              '当社は、1918年（大正7年）創業の機械メーカーです。静脈産業で挑戦する人たちと業界の明るい未来をつくります。'
            )}
          </p>
          <a
            href={`${BASE}/about/`}
            className="group inline-flex items-center gap-3 text-white text-sm font-bold border border-white/20 px-6 py-3 hover:border-[#c0392b] hover:text-[#c0392b] transition-all duration-300 cursor-pointer whitespace-nowrap w-fit"
          >
            {t('Learn About Us', '私たちについて')}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        {/* Image side */}
        <div className="relative overflow-hidden min-h-[320px] lg:min-h-0 order-1 lg:order-2">
          <img
            src={`${BASE}/_resources/img_top/learnmore_about.jpg`}
            alt="About Us"
            className="absolute inset-0 w-full h-full object-cover object-top"
            style={{ filter: 'brightness(0.6) saturate(0.7)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#0a0a0a]"></div>
          {/* Floating number */}
          <div className="absolute bottom-8 right-8 text-white/10 text-[120px] font-black leading-none select-none">02</div>
        </div>
      </div>
    </section>
  );
}
